import LegalDocShell from "@/components/legal/LegalDocShell";

// Full 35-section NaturePulse Terms of Service. Anchor IDs are stable and
// referenced by /app/frontend/src/lib/legal.js and the site footer for deep
// linking. Do NOT rename an id without updating both places.
const S = [
  { id: "our-mission", title: "1. Our Mission", body: (
    <>
      <p>NaturePulse is intended to help create a continuously growing record of what people are observing in the natural world.</p>
      <p>Users may contribute observations concerning subjects such as:</p>
      <ul>
        <li>Plants and vegetation</li><li>Trees and forests</li><li>Agriculture and crops</li><li>Farmers Pulse observations</li>
        <li>Birds and nesting</li><li>Animals and wildlife</li><li>Insects and pollinators</li><li>Reptiles, amphibians and aquatic life</li>
        <li>Weather and climate</li><li>Rainfall, drought, flooding and storms</li><li>Rivers, lakes and water resources</li>
        <li>Soil and land conditions</li><li>Landscapes and habitats</li><li>Environmental changes</li>
        <li>Natural events</li><li>Seasonal changes</li><li>Agriculture and food production</li><li>Other nature-related observations</li>
      </ul>
      <p>NaturePulse may organize this information geographically and chronologically to help individuals, communities, students, farmers, researchers, educators, organizations, and others better understand our living planet.</p>
    </>
  )},
  { id: "farmers-pulse", title: "2. Farmers Pulse", body: (
    <>
      <p>Farmers Pulse is an agricultural feature within NaturePulse intended to help farmers, gardeners, growers, agricultural professionals, researchers, students, and communities document and exchange agricultural and environmental information.</p>
      <p>Farmers Pulse may provide features relating to:</p>
      <ul>
        <li>Farms and fields</li><li>Crops and varieties</li><li>Planting and harvesting</li><li>Soil conditions</li>
        <li>Rainfall and weather</li><li>Irrigation and water availability</li><li>Crop growth and flowering</li>
        <li>Pests and diseases</li><li>Weeds</li><li>Livestock and poultry</li><li>Pollinators and beneficial insects</li>
        <li>Drought and flooding</li><li>Agricultural alerts</li><li>Farm observations</li><li>Agricultural calendars and almanacs</li>
        <li>Agricultural research</li><li>Farm equipment and technology</li><li>Government agricultural programs</li>
        <li>Agricultural markets and prices</li><li>Farmer discussions and questions</li><li>AI-assisted agricultural information</li>
        <li>Photographic identification</li><li>Farm journals and historical records</li><li>Other agricultural information and services</li>
      </ul>
      <p>Farmers Pulse is primarily an information, documentation, observation, and community platform. It is not a substitute for professional agricultural, veterinary, scientific, financial, legal, pesticide, environmental, or other professional advice.</p>
    </>
  )},
  { id: "eligibility", title: "3. Eligibility", body: (
    <>
      <p>You must be legally permitted to use the Services under the laws applicable to you.</p>
      <p>If you are under the age required to consent to online services in your jurisdiction, you may use NaturePulse only with the involvement and permission of a parent, guardian, school, or other legally authorized adult.</p>
      <p>Certain features may have additional eligibility requirements.</p>
    </>
  )},
  { id: "accounts", title: "4. User Accounts", body: (
    <>
      <p>Some NaturePulse features may be available without registration. Other features may require an account.</p>
      <p>You agree to provide accurate information when creating or maintaining an account. You are responsible for activity occurring through your account and for maintaining the security of your login credentials or authentication methods.</p>
      <p>You must promptly notify us if you believe your account has been accessed without authorization.</p>
      <p>We may restrict, suspend, or terminate accounts that violate these Terms or create risks for NaturePulse, its users, or others.</p>
    </>
  )},
  { id: "user-content", title: "5. User-Generated Content", body: (
    <>
      <p>NaturePulse allows users to submit content ("User Content"), which may include:</p>
      <ul>
        <li>Photographs</li><li>Videos</li><li>Audio</li><li>Text</li><li>Articles</li><li>Comments</li><li>Questions</li><li>Answers</li>
        <li>Agricultural observations</li><li>Nature observations</li><li>Species identifications</li><li>Crop information</li>
        <li>Weather observations</li><li>Farm information</li><li>Dates and times</li><li>Location information</li>
        <li>Geographic coordinates</li><li>Tags</li><li>Links</li><li>Research observations</li><li>Environmental measurements</li>
        <li>Other submitted information</li>
      </ul>
      <p>You remain responsible for the User Content you submit. You represent that you own your User Content or have sufficient permission and legal rights to submit and share it through NaturePulse.</p>
      <p>Do not upload copyrighted photographs, videos, articles, maps, datasets, or other materials belonging to another person or organization unless you have permission or another lawful basis to do so.</p>
    </>
  )},
  { id: "content-ownership", title: "6. Ownership of Your Content", body: (
    <>
      <p>Except for the license granted below, you retain ownership of intellectual property rights you hold in your original User Content.</p>
      <p>For example, uploading a photograph you created does not automatically transfer ownership of the photograph to NaturePulse.</p>
      <p>However, NaturePulse requires permission to store, display, process, organize, index, analyze, distribute, and otherwise use submitted material in order to operate the platform.</p>
    </>
  )},
  { id: "content-license", title: "7. License You Grant NaturePulse", body: (
    <>
      <p>By submitting User Content, you grant NaturePulse a worldwide, non-exclusive, royalty-free, transferable and sublicensable license to host, store, reproduce, process, organize, index, display, publish, translate, adapt, format, distribute, analyze, and otherwise use that content as reasonably necessary to:</p>
      <ul>
        <li>Operate NaturePulse and Farmers Pulse;</li>
        <li>Display your contributions;</li>
        <li>Generate maps and timelines;</li>
        <li>Organize observations geographically;</li>
        <li>Provide search and discovery;</li>
        <li>Generate summaries and statistics;</li>
        <li>Create aggregated datasets;</li>
        <li>Improve NaturePulse services;</li>
        <li>Provide AI-assisted features;</li>
        <li>Create educational and informational materials;</li>
        <li>Support environmental and agricultural analysis;</li>
        <li>Promote NaturePulse and its mission;</li>
        <li>Share content between appropriate NaturePulse services;</li>
        <li>Preserve community and historical records; and</li>
        <li>Support research and public-interest uses described by the Services.</li>
      </ul>
      <p>This license does not mean NaturePulse owns your original content. Where practical, NaturePulse may provide attribution to the contributor. Additional choices or licenses may be offered for users who wish to make particular observations, photographs, or datasets openly available.</p>
    </>
  )},
  { id: "public-private", title: "8. Public and Private Information", body: (
    <>
      <p>NaturePulse may allow users to designate certain information as public, private, restricted, or shared with selected audiences.</p>
      <p>Information marked public may be:</p>
      <ul>
        <li>Viewed by anyone;</li><li>Indexed by search engines;</li><li>Displayed on maps;</li>
        <li>Shared through NaturePulse;</li><li>Included in geographic or topic pages;</li>
        <li>Included in aggregated observations;</li><li>Referenced by other users; and</li>
        <li>Used in accordance with these Terms.</li>
      </ul>
      <p>Users should carefully consider what they make public. Never publicly post sensitive personal information that could place you or another person at risk.</p>
    </>
  )},
  { id: "location", title: "9. Location and GPS Information", body: (
    <>
      <p>Many NaturePulse observations are more useful when associated with a location. NaturePulse may therefore allow or request geographic information such as:</p>
      <ul>
        <li>Country</li><li>State or province</li><li>District or county</li><li>City</li><li>Town</li><li>Village</li>
        <li>General area</li><li>Farm location</li><li>GPS coordinates</li>
      </ul>
      <p>You control the information you submit, subject to the settings and features available through the Service. NaturePulse may reduce, obscure, generalize, or withhold precise locations when appropriate, particularly for sensitive wildlife, endangered species, private property, farms, or other locations where publication could create security, privacy, conservation, or safety risks.</p>
      <p>Users should avoid publishing precise locations when doing so could endanger people, property, wildlife, crops, habitats, or protected species.</p>
    </>
  )},
  { id: "citizen-science", title: "10. Citizen Science and Research", body: (
    <>
      <p>NaturePulse is intended in part to encourage public participation in documenting nature, agriculture, biodiversity, climate, and environmental change.</p>
      <p>User observations may therefore contribute to aggregated information useful for:</p>
      <ul>
        <li>Education</li><li>Citizen science</li><li>Environmental research</li><li>Agricultural research</li>
        <li>Biodiversity studies</li><li>Climate studies</li><li>Conservation</li><li>Historical comparisons</li>
        <li>Statistical analysis</li><li>Community planning</li><li>Public-interest research</li>
      </ul>
      <p>NaturePulse may make aggregated, anonymized, de-identified, or otherwise appropriately processed information available to researchers, educational institutions, governments, nonprofit organizations, or other organizations where consistent with our Privacy Policy and applicable law.</p>
      <p>NaturePulse does not guarantee that user-contributed observations satisfy scientific research standards. Researchers are responsible for evaluating data quality and suitability before using NaturePulse information for research or decision-making.</p>
    </>
  )},
  { id: "ai-features", title: "11. AI-Assisted Features", body: (
    <>
      <p>NaturePulse and Farmers Pulse may use artificial intelligence and automated systems to assist with functions such as:</p>
      <ul>
        <li>Plant identification</li><li>Animal identification</li><li>Bird identification</li><li>Insect identification</li>
        <li>Crop identification</li><li>Pest identification</li><li>Possible disease recognition</li><li>Image analysis</li>
        <li>Suggested titles</li><li>Descriptions</li><li>Tags and categories</li><li>Translation</li><li>Summaries</li>
        <li>Search</li><li>Agricultural information</li><li>Environmental analysis</li><li>Recommendations</li>
      </ul>
      <p>AI-generated information can be incorrect. An AI system may misidentify a species, crop, disease, insect, environmental condition, or other subject. Users must independently verify important information before relying upon it.</p>
      <p>Never rely solely on an AI-generated identification or recommendation when human health, animal health, crop safety, pesticide application, food safety, environmental safety, financial loss, or another significant decision may be involved.</p>
      <p>For a fuller explanation of how AI is used across NaturePulse, see the <a href="/legal/ai">AI Use &amp; Agricultural Disclaimer Policy</a>.</p>
    </>
  )},
  { id: "agriculture-disclaimer", title: "12. Agricultural Information Disclaimer", body: (
    <>
      <p>Information available through Farmers Pulse is provided for general informational and educational purposes.</p>
      <p>NaturePulse does not guarantee the accuracy of information concerning:</p>
      <ul>
        <li>Planting dates</li><li>Harvest dates</li><li>Crop varieties</li><li>Yield</li>
        <li>Soil recommendations</li><li>Fertilizers</li><li>Pesticides</li><li>Herbicides</li><li>Fungicides</li>
        <li>Irrigation</li><li>Pest identification</li><li>Plant diseases</li><li>Livestock conditions</li>
        <li>Agricultural chemicals</li><li>Weather</li><li>Crop prices</li><li>Market conditions</li>
        <li>Government programs</li><li>Agricultural regulations</li>
      </ul>
      <p>Conditions vary significantly according to geography, soil, climate, crop variety, weather, farming practices, and other factors. Consult qualified agricultural extension professionals, agronomists, veterinarians, pesticide professionals, government agencies, or other appropriate experts before making important agricultural decisions.</p>
    </>
  )},
  { id: "pesticides", title: "13. Pesticides, Chemicals and Agricultural Treatments", body: (
    <>
      <p>NaturePulse does not prescribe pesticides, herbicides, fungicides, fertilizers, veterinary medications, or other regulated agricultural products.</p>
      <p>If information concerning these products appears on Farmers Pulse, users must verify that the product and proposed use are lawful and appropriate in their jurisdiction.</p>
      <p>Always follow applicable laws and the official product label. The label and applicable regulatory requirements take precedence over community posts, AI-generated information, articles, or recommendations appearing on NaturePulse.</p>
    </>
  )},
  { id: "weather-alerts", title: "14. Weather and Environmental Alerts", body: (
    <>
      <p>NaturePulse may display weather forecasts, warnings, environmental alerts, drought information, flood information, fire information, or similar information obtained from users or third-party sources.</p>
      <p>NaturePulse is not an emergency warning service. Do not rely exclusively on NaturePulse for information affecting personal safety, livestock safety, evacuation, severe weather preparation, wildfire response, flooding, or other emergencies.</p>
      <p>Users should monitor official government and emergency-management sources.</p>
    </>
  )},
  { id: "market-prices", title: "15. Market Prices and Financial Information", body: (
    <>
      <p>Farmers Pulse may display agricultural commodity prices, farmer-reported prices, market information, purchasing opportunities, or related economic information.</p>
      <p>Prices may be delayed, incomplete, incorrect, estimated, or applicable only to particular markets.</p>
      <p>NaturePulse does not guarantee market prices and does not provide investment, commodity trading, business, tax, or financial advice.</p>
      <p>Users are responsible for independently verifying prices before making commercial decisions.</p>
    </>
  )},
  { id: "community", title: "16. Community Discussions", body: (
    <>
      <p>NaturePulse may provide comments, questions, discussions, messaging, farmer communities, expert contributions, or similar interactive services.</p>
      <p>Users must treat one another respectfully. You may disagree with another user's observation or interpretation, but harassment, threats, intimidation, hate speech, or personal attacks are not permitted.</p>
      <p>NaturePulse may moderate or remove content and may restrict accounts when reasonably necessary to protect the community.</p>
    </>
  )},
  { id: "prohibited-content", title: "17. Prohibited Content and Conduct", body: (
    <>
      <p>You may not use NaturePulse to submit or distribute content that:</p>
      <ul>
        <li>Violates applicable law;</li>
        <li>Is knowingly false or fraudulent;</li>
        <li>Is defamatory;</li>
        <li>Threatens or harasses another person;</li>
        <li>Promotes violence;</li>
        <li>Contains unlawful hate or discriminatory content;</li>
        <li>Exploits or endangers children;</li>
        <li>Violates another person's privacy;</li>
        <li>Infringes copyrights, trademarks, or other intellectual property rights;</li>
        <li>Contains malware or malicious software;</li>
        <li>Promotes illegal wildlife trafficking;</li>
        <li>Encourages unlawful hunting or poaching;</li>
        <li>Reveals sensitive locations of protected species with harmful intent;</li>
        <li>Promotes unsafe or unlawful agricultural chemical use;</li>
        <li>Manipulates agricultural market information;</li>
        <li>Impersonates another person or organization;</li>
        <li>Uses automated systems to spam or disrupt the platform; or</li>
        <li>Otherwise abuses NaturePulse or its community.</li>
      </ul>
    </>
  )},
  { id: "species-safety", title: "18. Species Identification and Wildlife Safety", body: (
    <>
      <p>NaturePulse may provide community or AI-assisted species identification. Such identification is not guaranteed to be accurate.</p>
      <p>Do not consume plants, mushrooms, berries, fruits, herbs, insects, fish, or other organisms solely because NaturePulse, AI, or another user identifies them as edible.</p>
      <p>Do not approach, handle, feed, capture, or disturb wildlife based solely upon information provided through NaturePulse. Observe wildlife responsibly and comply with applicable laws.</p>
    </>
  )},
  { id: "private-property", title: "19. Private Property and Farm Access", body: (
    <>
      <p>The appearance of a farm, natural area, observation, photograph, trail, plant, animal, or geographic location on NaturePulse does not mean the public has permission to enter that property.</p>
      <p>Users must respect:</p>
      <ul>
        <li>Private property</li><li>Farms</li><li>Agricultural fields</li><li>Protected lands</li>
        <li>Indigenous lands</li><li>Conservation areas</li><li>Restricted areas</li><li>Wildlife habitats</li>
      </ul>
      <p>Always obtain appropriate permission before entering private property.</p>
    </>
  )},
  { id: "third-party", title: "20. External Links and Third-Party Content", body: (
    <>
      <p>NaturePulse may link to:</p>
      <ul>
        <li>Government websites</li><li>Universities</li><li>Research institutions</li>
        <li>Agricultural organizations</li><li>News publishers</li><li>Social media</li>
        <li>Videos</li><li>Blogs</li><li>Weather providers</li>
        <li>Market information services</li><li>Businesses</li><li>Other third-party websites</li>
      </ul>
      <p>A link does not necessarily constitute endorsement. NaturePulse does not control third-party websites and is not responsible for their availability, accuracy, privacy practices, security, products, services, or content.</p>
      <p>Third-party terms and privacy policies may apply when you leave NaturePulse.</p>
    </>
  )},
  { id: "copyright", title: "21. Copyright and Intellectual Property", body: (
    <>
      <p>NaturePulse's original website design, software, logos, trademarks, graphics, databases, compilations, and original editorial materials are protected by applicable intellectual property laws.</p>
      <p>You may not copy, reproduce, scrape, republish, sell, or commercially exploit protected NaturePulse material except as permitted by law or with our authorization.</p>
      <p>User Content remains subject to the rights described elsewhere in these Terms.</p>
    </>
  )},
  { id: "copyright-complaints", title: "22. Copyright Complaints", body: (
    <>
      <p>If you believe material appearing on NaturePulse infringes your copyright or other intellectual property rights, please contact us at:</p>
      <p><a href="mailto:legal@naturepulse.net">legal@naturepulse.net</a></p>
      <p>Please identify:</p>
      <ul>
        <li>The copyrighted work;</li>
        <li>The allegedly infringing material;</li>
        <li>Where the material appears;</li>
        <li>Your contact information; and</li>
        <li>The basis for your claim.</li>
      </ul>
      <p>We may request additional information before acting upon a complaint.</p>
    </>
  )},
  { id: "data-accuracy", title: "23. Data Accuracy", body: (
    <>
      <p>NaturePulse contains information contributed by many different sources. We do not guarantee that information is:</p>
      <ul>
        <li>Accurate</li><li>Complete</li><li>Scientifically verified</li>
        <li>Current</li><li>Error-free</li><li>Suitable for any particular purpose</li>
      </ul>
      <p>An observation represents what a contributor reported at a particular time and location. NaturePulse may provide verification, expert review, AI analysis, community confirmation, or confidence indicators, but these should not be interpreted as guarantees.</p>
    </>
  )},
  { id: "moderation", title: "24. Moderation and Removal", body: (
    <>
      <p>NaturePulse reserves the right to review, moderate, restrict, label, correct, archive, reject, or remove content when reasonably necessary. We may take action regarding content that:</p>
      <ul>
        <li>Violates these Terms;</li>
        <li>Appears fraudulent;</li>
        <li>Creates safety concerns;</li>
        <li>Violates intellectual property rights;</li>
        <li>Threatens privacy;</li>
        <li>Contains spam;</li>
        <li>Contains malicious content; or</li>
        <li>Could harm the integrity of the NaturePulse community or datasets.</li>
      </ul>
      <p>We are not obligated to monitor every submission.</p>
    </>
  )},
  { id: "termination", title: "25. Account Suspension and Termination", body: (
    <>
      <p>We may suspend or terminate access to NaturePulse when a user materially or repeatedly violates these Terms, applicable law, community rules, or the rights or safety of others.</p>
      <p>Users may discontinue use of NaturePulse at any time. Account deletion and the treatment of associated personal information will be handled according to our Privacy Policy and applicable law.</p>
      <p>Some public contributions may remain in aggregated, anonymized, archival, research, backup, or community datasets where legally permissible and reasonably necessary to preserve the integrity of historical observations.</p>
    </>
  )},
  { id: "availability", title: "26. Service Availability", body: (
    <>
      <p>NaturePulse is continually evolving. We may add, modify, suspend, discontinue, or replace features at any time.</p>
      <p>We do not guarantee that NaturePulse, Farmers Pulse, AI services, maps, databases, alerts, APIs, or other features will always be available or uninterrupted.</p>
    </>
  )},
  { id: "no-advice", title: "27. No Professional Advice", body: (
    <>
      <p>Nothing provided through NaturePulse should be interpreted as professional:</p>
      <ul>
        <li>Agricultural advice</li><li>Veterinary advice</li><li>Medical advice</li>
        <li>Legal advice</li><li>Financial advice</li><li>Investment advice</li>
        <li>Engineering advice</li><li>Emergency advice</li><li>Environmental compliance advice</li>
      </ul>
      <p>Professional decisions should be made with appropriately qualified professionals.</p>
    </>
  )},
  { id: "warranties", title: "28. Disclaimer of Warranties", body: (
    <>
      <p>To the maximum extent permitted by applicable law, NaturePulse and its Services are provided "as is" and "as available."</p>
      <p>We make no guarantee regarding the accuracy, reliability, completeness, availability, safety, or suitability of the Services or information provided through them.</p>
      <p>Your use of NaturePulse and reliance upon information available through the Services is at your own risk.</p>
    </>
  )},
  { id: "liability", title: "29. Limitation of Liability", body: (
    <>
      <p>To the maximum extent permitted by applicable law, NaturePulse and its owners, operators, affiliates, officers, employees, contractors, and service providers will not be liable for indirect, incidental, special, consequential, exemplary, or punitive damages arising from your use of or inability to use the Services.</p>
      <p>This includes, without limitation and where legally permissible, losses arising from reliance on weather information, agricultural information, AI-generated information, species identification, crop recommendations, market information, user contributions, third-party content, or interruptions of the Services.</p>
      <p>Nothing in these Terms excludes liability that cannot legally be excluded.</p>
    </>
  )},
  { id: "indemnification", title: "30. Indemnification", body: (
    <>
      <p>To the extent permitted by applicable law, you agree to defend, indemnify, and hold harmless NaturePulse and its owners, operators, affiliates, officers, employees, and service providers from claims, damages, liabilities, losses, and reasonable expenses arising from:</p>
      <ul>
        <li>Your violation of these Terms;</li>
        <li>Your User Content;</li>
        <li>Your infringement of another person's rights;</li>
        <li>Your unlawful use of the Services; or</li>
        <li>Your misuse of information obtained through NaturePulse.</li>
      </ul>
    </>
  )},
  { id: "privacy", title: "31. Privacy", body: (
    <>
      <p>Your use of NaturePulse is also governed by the <a href="/privacy">NaturePulse Privacy Policy</a>.</p>
      <p>Because NaturePulse may process photographs, observations, account information, geographic information, and other data, we encourage every user to review the Privacy Policy carefully.</p>
      <p>Farmers should pay particular attention to privacy settings associated with precise farm and field locations.</p>
    </>
  )},
  { id: "changes", title: "32. Changes to These Terms", body: (
    <>
      <p>NaturePulse may update these Terms as the platform develops. When significant changes are made, we may provide notice through the website, account interface, email, or another reasonable method.</p>
      <p>The "Last Updated" date will indicate the latest revision. Continued use of the Services after revised Terms become effective constitutes acceptance to the extent permitted by applicable law.</p>
    </>
  )},
  { id: "governing-law", title: "33. Governing Law", body: (
    <>
      <p>These Terms shall be governed by the laws of the State of Oregon, USA, without regard to conflict-of-law principles, except where applicable consumer or other laws require otherwise.</p>
      <p>Any dispute shall be handled in the courts or other dispute-resolution forum specified by applicable law and any additional dispute-resolution provisions adopted by NaturePulse.</p>
    </>
  )},
  { id: "international", title: "34. International Users", body: (
    <>
      <p>NaturePulse is intended to become a global platform. Users accessing NaturePulse from outside the jurisdiction in which NaturePulse operates are responsible for complying with applicable local laws.</p>
      <p>Agricultural regulations, pesticides, wildlife protections, privacy requirements, data rules, and other laws differ substantially between countries. Information appropriate in one country may not be appropriate or lawful in another.</p>
    </>
  )},
  { id: "contact", title: "35. Contact Us", body: (
    <>
      <p>Questions regarding these Terms may be sent to:</p>
      <p>
        <strong>NaturePulse</strong><br />
        Website: <a href="https://naturepulse.net">NaturePulse.net</a><br />
        Email: <a href="mailto:legal@naturepulse.net">legal@naturepulse.net</a><br />
        Address: Portland, Oregon, USA
      </p>
    </>
  )},
];

export default function TermsOfService() {
  return (
    <LegalDocShell
      eyebrow="NaturePulse · Terms of Service"
      title="Terms of Service"
      effective="August 24, 2026"
      updated="August 24, 2026"
      intro={
        <>
          <p>Welcome to NaturePulse.net ("NaturePulse," "we," "us," or "our"). NaturePulse.net, a division of Social Pulse Inc, is a platform designed to help individuals and communities observe, document, learn about, and share information concerning nature, climate, agriculture, biodiversity, wildlife, plants, weather, environmental conditions, and our changing planet.</p>
          <p>NaturePulse may include specialized services and sections, including Farmers Pulse, community discussions, maps, photographs, observations, blogs, alerts, research resources, artificial intelligence ("AI") tools, and other services that we may introduce from time to time.</p>
          <p>These Terms of Service ("Terms") govern your access to and use of NaturePulse.net and related NaturePulse websites, applications, tools, features, databases, and services that reference these Terms (collectively, the "Services").</p>
          <p>By accessing, registering for, contributing to, or using the Services, you agree to these Terms and our <a href="/privacy">Privacy Policy</a>. If you do not agree, please do not use the Services.</p>
        </>
      }
      sections={S}
    />
  );
}
